<template>
  <section class="" style="background: #F6F6F6;color:black">
    <div class="container ">
      <div class="section-title page-title">

        <div class="row m-0">
          <div class="col-12">
            <div class="content text-center">

              <ContentsCapitalLabel
                isSecondaryColor="true"
                label="DESIGN, FUNCTIONAL REQUIREMENT, SIMULATION, PROTOTYPING, VALIDATION"
              />
      
              <h2 class="title h2-caslon text-black text-center f-44 fw-600">Material Selection & Products Development Support</h2>

            </div>
          </div>
        </div>
        
      </div>
    </div>
  </section>
  
  <section class="section-product-detail-page bg-primary">
    <div class="container">
      <div class="page-content">

        <div class="content">
          <ContentsTextWithImage
            title="Material Selection & Products Development Support"
            image-url="/pages/products/services/service-sec01.jpg"
            :contents="[
              'Are you confused when molded parts are crack, deformed, or shift in color? Not sure what material is satisfied your requirement? Want to cost down by new material? Metal replacement? or want to introduce new product? Choosing the right material can be awkward especially when it comes to newly developed product. At Nagase we work closely with partners and customer by involving in early development stage starting from listening to customer challenge, conceptual design, functional requirement, material selection, design development, simulation, prototyping, tooling, validation to launch. Working with us will help you to reduce development time and resources. We’re willing to help from start to part at no cost.',
            ]"
            is-reverse="true"
            is-white-content="true"
            left-width="45.805%"
            right-width="54.195%"
          />
        </div>

      </div>
    </div>
  </section>

  <section class="section-product-detail-page">
    <div class="container">
      <div class="page-content">
        <div class="content">

          <!-- CONTENT IMAGE RIGHT TEXT LEFT -->
          <div class="content-image-text custom-content-image-text">
            <div class="image text-center">
              <img src="/pages/products/services/Screen-Shot-2022-06-07-at-5.21.07-PM.png" alt="Case sample examples">
            </div>
            <div class="content ">
              <span class="title">Case sample</span>
              <!-- Paragraph tags -->
              <p>Metal to plastic for water pump motor <br>
                Metal to plastic for water meter <br>
                Medical equipment housing with EMI shielding plastic compound <br>
                Metal to plastic in automotive body part <br>
                Metal to plastic in automotive under the hood <br>
                Post-consumer recycle / Chemically recycled material materials for consumer products <br>
                Radar absorbing material for ADAS <br>
                Medical equipment by high heat material <br>
                EV battery pack <br>
                High heat material for food packaging <br>
                Lightweight material for air conditioning parts <br>
                ESD material for semiconductor handling <br>
                Replacement of materials for lightweight and cost reduction</p>
              <!-- Paragraph tags -->
            </div>
          </div>
          <!-- CONTENT IMAGE RIGHT TEXT LEFT -->

        </div>
      </div>
    </div>
  </section>

</template>
<script setup lang="ts">
useHead({
  title:'Material Selection & Products Development Support - NAGASE THAILAND Engineering Plastics',
})
</script>

<style scoped>
.page-title {
  padding: 50px 0 0;
}
.page-title .title {
  margin: 40px 0 30px;
}

.custom-content-image-text {
  padding-top: 33px;
}

.custom-content-image-text .image img {
  width: auto;
}

.custom-content-image-text .content .title {
  font-family: 'Open Sans', sans-serif;
  font-size: 19px;
  font-weight: 600;

  color: #353535;

  display: block;
  margin-bottom: 25px;
}

.custom-content-image-text .content p {
  font-family: 'Myriad-Pro', sans-serif;
  font-weight: 400;
  font-size: 15px;

  line-height: 22.8px;
  /* letter-spacing: -0.2px; */

  color: #54595F;
}
</style>